import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('configuration-section')
export class ConfigurationSection extends LitElement {

	static styles = css`
	  :host {
		display: flex;
		flex-direction: row;
		height: 100%;
		pointer-events: none;
	  }
		@media (max-width: 359px) {
			:host {
				align-items: flex-start;
			}
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<feature-container .featureList=${this.section.features}></feature-container>
		`;
	}
}
